var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.001,
    cy: 112,
    r: 112,
    fill: "#ECFDF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.001,
    cy: 112,
    r: 81,
    fill: "#D1FADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_6356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2986 145.289L115.692 133.715C120.637 131.959 122.07 125.617 118.344 121.89L102.111 105.658C98.3844 101.931 92.0778 103.364 90.2861 108.309L78.7119 140.703C77.7086 143.569 80.4319 146.293 83.2986 145.289Z",
    fill: "#52AD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.966 112L141.098 93.8685C142.854 92.1127 145.684 92.1127 147.44 93.8685L147.655 94.0835C148.694 95.1227 150.414 95.1227 151.454 94.0835C152.493 93.0444 152.493 91.3244 151.454 90.2852L151.239 90.0702C147.404 86.236 141.134 86.236 137.299 90.0702L119.168 108.202C118.129 109.241 118.129 110.961 119.168 112C120.207 113.039 121.927 113.039 122.966 112Z",
    fill: "#52AD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.049 93.6533L104.834 93.8683C103.795 94.9075 103.795 96.6275 104.834 97.6667C105.874 98.7058 107.594 98.7058 108.633 97.6667L108.848 97.4517C112.682 93.6175 112.682 87.3467 108.848 83.5125L108.669 83.3333C107.594 82.2583 105.874 82.2583 104.834 83.3333C103.795 84.3725 103.795 86.0925 104.834 87.1317L105.049 87.3467C106.769 89.0667 106.769 91.9333 105.049 93.6533Z",
    fill: "#52AD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.133 111.57L126.334 115.369C125.295 116.408 125.295 118.128 126.334 119.167C127.374 120.206 129.094 120.206 130.133 119.167L133.931 115.369C135.687 113.613 138.518 113.613 140.274 115.369L144.144 119.239C145.183 120.278 146.903 120.278 147.942 119.239C148.981 118.199 148.981 116.479 147.942 115.44L144.072 111.57C140.202 107.736 133.967 107.736 130.133 111.57Z",
    fill: "#52AD33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.966 90.0701L112.001 101.035C110.962 102.074 110.962 103.794 112.001 104.833C113.04 105.873 114.76 105.873 115.799 104.833L126.764 93.8684C130.599 90.0343 130.599 83.7634 126.764 79.9293L122.966 76.1309C121.927 75.0918 120.207 75.0918 119.168 76.1309C118.129 77.1701 118.129 78.8901 119.168 79.9293L122.966 83.7276C124.686 85.4834 124.686 88.3501 122.966 90.0701Z",
    fill: "#52AD33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_6356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white",
    transform: "translate(69.0011 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractSuccess);
export default __webpack_public_path__ + "static/media/ContractSuccess.4006e91d03ed8c936ef82b9234b74b38.svg";
export { ForwardRef as ReactComponent };